import { IStatusInfo } from './Status';

export interface IEquipmentInspectionPointInfo {
    EquipmentInspectionPointID: number;
    PreOrPost: boolean;
    ValueString: string|null;
    ValueInt: number|null;
    ValueBoolean: boolean|null;
    ValueDecimal2: number|null
}
export class EquipmentInspectionPointInfo implements IEquipmentInspectionPointInfo
{
    constructor(
        public EquipmentInspectionPointID: number,
        public PreOrPost: boolean,
        public ValueString: string|null,
        public ValueInt: number|null,
        public ValueBoolean: boolean|null,
        public ValueDecimal2: number|null) {}
}
export interface ISafetyCheckItem {
    SafetyCheckID: number
    Result: number
}
export class SafetyCheckItem implements ISafetyCheckItem {
    constructor(
        public SafetyCheckID: number,
        public Result: number) {}
}
export interface IGARInfo {
    ActivityLogGARID: number
    Supervision: number
    Planning: number
    CrewSelection: number
    Endurance: number
    Weather: number
    CaseComplexity: number
    Total: number
}
export class GARInfo implements IGARInfo
{
    constructor(
        public ActivityLogGARID: number,
        public Supervision: number,
        public Planning: number,
        public CrewSelection: number,
        public Endurance: number,
        public Weather: number,
        public CaseComplexity: number,
        public Total: number) {}
}
export interface IViolationInfo {
    ActivityLogViolationID: number,
    ViolationTypeID: number|null,
    Description: string
    Fee: number|null
}
export interface ILocalIdentifier {
    ID: number;
    IsLocal: boolean;
}

export interface ILocalIdentifierPerson {
    ID: number;
    IsLocal: boolean;
    ActivityLogRoleID: number|null;
    Name: string;
}
export interface IActivityLogResult {
    ActivityLogID: number;
    ActivityLogEntryTypeID: number;
    ClientID: string;
    LoginID: string;
    DateStarting: string;
    DateEnding: string;
    Comments: string;
    ActivityType: string;
    Category: string;
    Pinned:boolean|null;
    Latitude: number|null;
    Longitude: number|null;
    Location: string;
    EquipmentID: number|null;
    EquipmentStatusID: number|null;
    Quantity: number|null;
    WeatherID: number|null;
    WindID:number|null;
    SeasID: number|null;
    PermitID: number|null;
    MooringID: number|null;
    Tide: string;
    IncidentDispositionID: number|null;
    Warning: boolean|null;
    Approved: boolean|null;
    ApprovedBy: string;
    TicketNumber: string;
    DeliveryMethodID: number|null;
    DeliveryDate: string;
    Fine: number;
    IsPrivate:boolean|null;
    VesselLength: number|null;
    ConditionsSource: string;
    Persons: ILocalIdentifierPerson[];
    Vessels: ILocalIdentifier[];
    Users: string[];
    Vehicles: number[];
    Photos: IActivityPhotoItem[];
    InspectionPoints: IEquipmentInspectionPointInfo[];
    Violations: IViolationInfo[];
    SafetyChecks: ISafetyCheckItem[];
    GAR: IGARInfo;
}
export interface IActivityLogResult_Response {
    Status: IStatusInfo;
    Result: IActivityLogResult;
}
export interface IActivityLogSearchResult {
    ActivityLogID: number;
    ActivityLogEntryTypeID: number;
    ClientID: string;
    LoginID: string;
    DateStarting: string;
    DateEnding: string;
    Comments: string;
    ActivityType: string;
    Category: string;
    ConditionTitle:string;
    EquipmentTitle:string;
    PumpoutTitle:string;
    ViolationTitle:string;
    SafetyCheckTitle:string;
    GARTotal: number;
    Pinned:boolean;
}
export interface ILogSearch_Response {
    Status: IStatusInfo;
    Results: IActivityLogSearchResult[];
    SearchDate: Date;
}
export interface IActivityPhotoItem {
    PhotoID: number;
    FileName: string;
    FileUrl: string;
}
export class ViolationInfo implements IViolationInfo {
    constructor (
        public ActivityLogViolationID: number,
        public ViolationTypeID: number|null,
        public Description: string,
        public Fee: number|null) {}
}
